<div #contentContainer class="content">
  {{ contentValue }}
</div>
@if (canExpand) {
  <div class="expand-container">
    <button
      blazeBarButton="secondary"
      type="button"
      class="expand-button"
      (click)="toggleExpand()"
      >{{ expandButtonLabel }}</button
    >
  </div>
}
